import AWSExports from './aws-exports';

// eslint-disable-next-line import/prefer-default-export
export const getImageUrl = (objectName) => encodeURI(`https://${AWSExports.aws_user_files_s3_bucket}.s3.amazonaws.com/public/${objectName}`);
